import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);
const $ = jQuery.noConflict();

'use strict';
const Animations = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	/** @description Initialize */
	$domCounter: $('.js-switcher'),
	init: function() {
		if (document.body.classList.contains('disabled-animations')) {
			return;
		}
		this.typingText();
	},
	typingText: function() {
		// header
		if (window.innerWidth > 991) {
			// gsap-site preload fade
			gsap.to('.gsap-site', {
				opacity: 1,
				duration: 0.5,
				ease: 'power1.inOut',
			});
			// container
			gsap.from('.gsap-container', {
				opacity: 0,
				delay: 1,
			});

			// hero title
			gsap.utils.toArray('.gsap-title').forEach(function(elem) {
				const split = new SplitText(elem, {type: 'lines'});
				gsap.from (
					split.lines, .6, {
						y: 30,
						opacity: 0,
						delay: 1,
						ease: 'power1.inOut',
						stagger: {
							amount: 0.5,
						},
					}
				);
			});

			// entry content
			gsap.utils.toArray('.gsap-entry-content').forEach(function(elem) {
				gsap.from(elem, {
					duration: 0.3,
					opacity: 0,
					scrollTrigger: {
						trigger: elem,
						start: 'top 70%',
						end: 'bottom 20%'
					}
				});
			});
			gsap.utils.toArray('.gasp-bottom').forEach(function(elem) {
				gsap.from(elem, {
					duration: 0.2,
					y: 50,
					opacity: 0,
					ease: 'power1.inOut',
					scrollTrigger: {
						trigger: elem,
						start: 'top 100%',
						end: 'bottom 20%',
					}
				});
			});
			gsap.utils.toArray('.gasp-top').forEach(function(elem) {
				gsap.from(elem, {
					duration: .7,
					y: -50,
					opacity: 0,
					scrollTrigger: {
						trigger: elem,
						start: 'top 80%',
						end: 'bottom 20%',
					}
				});
			});
			gsap.utils.toArray('.gsap-pretitle').forEach(function(elem) {
				const splitTimeline = gsap.timeline({scrollTrigger: {
					trigger: elem,
				}
				});
				const split = new SplitText(elem);
				splitTimeline.from (
					split.chars, {
						duration: 0.2,
						opacity: 1,
						scale: 0,
						y: 80,
						rotationX: 100,
						transformOrigin: '0% 50% -50',
						ease: 'back',
						stagger: 0.02,
						onComplete: removeSplit
					}, '+=0'
				);
				function removeSplit() {
					split.revert();
				}
			});
			gsap.utils.toArray('.gsap-list').forEach(function(elem) {
				const splitTimeline = gsap.timeline({scrollTrigger: {
					trigger: elem,
				}
				});
				const split = new SplitText(elem);
				splitTimeline.from (
					split.chars, {
						duration: 0.2,
						opacity: 1,
						scale: 0,
						y: 80,
						rotationX: 100,
						transformOrigin: '0% 50% -50',
						ease: 'back',
						stagger: 0.02,
						onComplete: removeSplit
					}, '+=0'
				);
				function removeSplit() {
					split.revert();
				}
			});
			gsap.utils.toArray('.gasp-left').forEach(function(elem) {
				gsap.from(elem, {
					duration: 0.1,
					x: -50,
					opacity: 0,
					scrollTrigger: {
						trigger: elem,
						start: 'top 70%',
						end: 'bottom 20%'
					}
				});
			});
			gsap.utils.toArray('.gasp-right').forEach(function(elem) {
				gsap.from(elem, {
					duration: 1,
					x: 50,
					opacity: 0,
					scrollTrigger: {
						trigger: elem,
						start: 'top 70%',
						end: 'bottom 20%',
					}
				});
			});
			gsap.utils.toArray('.gsap-button').forEach((elem, i) => {
				gsap.from(elem, {
					opacity: 0,
					duration: .4,
					delay: i * 0.2,
					scrollTrigger: {
						trigger: elem,
						start: 'top 60%',
						end: 'bottom center',
					}
				});
			});
		}
	}
};

export default Animations;